// actions/news.ts — M1
import { defineAction } from '../define';
import { g } from '../guard';
import type { NewsItem } from '../../types/news';
declare module '../registry' {
  interface ActionMap { 'news.list': { req: { before: number | null }; res: { items: NewsItem[]; more: boolean } } }
}
export const newsList = defineAction('news.list', g.obj({ before: g.nullable(g.int(0, 2 ** 31)) }));
